const updateSelects = selects => options => {
  return options ? selects.forEach((select, index) => {
    select.value = options[index] ? options[index] : '';
  }) : false;
}

export default updateSelects